import { DateTime } from "luxon"

//PrimeReact
import { Calendar } from "primereact/calendar"

//Assessments
import {
  getAssessmentDateOnlyFromIso,
  getAssessmentDateOnlyISO,
  getAssessmentTimeOnlyISO,
} from "../../helpers/assessmentDateHelper"

export default function QuestionInputCalendar({ value, question, onSetValue }) {
  let minDate = undefined
  let maxDate = undefined
  let dateValue = undefined
  let viewDate = undefined

  if (value) {
    let translatedValue = getAssessmentDateOnlyFromIso(value)

    if (translatedValue.isValid) {
      dateValue = translatedValue.toJSDate()
    }
  }

  if (question.minValue) {
    minDate = getAssessmentDateOnlyFromIso(question.minValue)
  }

  if (question.maxValue) {
    maxDate = getAssessmentDateOnlyFromIso(question.maxValue)

    if (!dateValue) {
      viewDate = maxDate
    }
  }

  if (question.verifyAge && question.minAge) {
    const minAgeDate = DateTime.now().plus({ years: -question.minAge })

    if (!maxDate || minAgeDate > maxDate) {
      maxDate = minAgeDate

      if (!dateValue) {
        viewDate = maxDate
      }
    }
  }

  if (question.allowPastDates === false) {
    minDate = DateTime.now()
  }

  if (question.allowFutureDates === false) {
    maxDate = DateTime.now()
  }

  return (
    <Calendar
      value={dateValue}
      onChange={(e) => {
        let newDateValue = undefined

        if (minDate?.isValid && minDate.toJSDate() > e.value) {
          newDateValue = getAssessmentDateOnlyISO(minDate.toJSDate())
        } else if (maxDate?.isValid && maxDate?.toJSDate() < e.value) {
          newDateValue = getAssessmentDateOnlyISO(maxDate.toJSDate())
        } else {
          newDateValue = getAssessmentDateOnlyISO(e.value)
        }

        onSetValue(newDateValue)
      }}
      style={{ width: "100%" }}
      minDate={minDate?.toJSDate()}
      maxDate={maxDate?.toJSDate()}
      viewDate={viewDate?.toJSDate()}
      showTime={false}
      showIcon
      iconPos="left"
    />
  )
}
